import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "Zero Unnecessary Downtime",
    body: "Every hour your truck sits in a bay costs your fleet revenue. We execute rapid diagnostics and precision repairs to get your rig back on the interstate.",
  },
  {
    number: "02",
    title: "Honest Fleet Pricing, No Surprises",
    body: "Clear upfront estimates, transparent labor breakdowns, and direct communication from Omar and Ray before any wrench is turned.",
  },
  {
    number: "03",
    title: "Heavy Equipment Mastery",
    body: "From Class 8 semi tractors to dump trucks and heavy haulers, our technicians possess deep mechanical mastery over all major diesel platforms.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-24 lg:py-32 bg-carbon carbon-texture" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="font-mono text-xs uppercase tracking-widest text-hazard font-semibold mb-3">/ 03 — The Shop Code</p>
          <h2 className="font-heading uppercase font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            How We <span className="chrome-text">Run the Bays</span>
          </h2>
        </motion.div>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start py-10 border-t border-steel last:border-b hover:bg-surface/60 transition-colors duration-500 px-2 sm:px-4"
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <span className="md:col-span-3 font-heading font-black text-6xl lg:text-7xl text-stroke-thin group-hover:text-hazard group-hover:[-webkit-text-stroke:0px] transition-all duration-500 select-none">
                {c.number}
              </span>
              <h3 className="md:col-span-4 font-heading uppercase font-bold text-2xl lg:text-3xl text-white leading-tight">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-slate-400 leading-relaxed text-sm sm:text-base">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
